import { getWithPath } from "@zmedia/bm-soccer-ui/utils/http";

const API_URL = {
    SEARCH: '/search/get/multi'
};

export interface ISearchParams {
    query: string;
}

export const SearchServices = {
    search: (
        query: string,
    ): Promise<any> => {
        const params: ISearchParams = {
            query,
        };
        return getWithPath(API_URL.SEARCH, params) as any;
    },
};
